import React, { useEffect, useState } from "react";
import TaskTable from "../components/tables/TaskTable";

// project to get members
// projectId to get tasks
// workStreamId to get tasks

const Tasks = ({
  project,
  projectId,
  workStreamId,
  loading,
  refreshInitiative,
}) => {
  const context = workStreamId ? "workstream" : "project";
  return (
    <div className="w-100 overflow-hidden">
      <TaskTable
        projectId={projectId}
        workStreamId={workStreamId}
        members={project?.members}
        context={context}
      />
    </div>
  );
};

export default Tasks;
